import { render, staticRenderFns } from "./d6.vue?vue&type=template&id=23fe1c0e&scoped=true"
import script from "./d6.vue?vue&type=script&lang=js"
export * from "./d6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fe1c0e",
  null
  
)

export default component.exports